import React, { useState, useEffect, useRef, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ConfigurationReportTab from './configurationTab';
import Sorting from '../../components/company_panel/common/sorting';
import { capitalizeAllFirstLetters, capitalizeFirstLetter, getBrandId, getCompany, getOutletId, getExcelColumnWidths } from '../../helpers/commonFunctions';
import CustomPagination from '../../components/company_panel/common/custompagination';
import Loader from '../../components/company_panel/common/loader';
import notFound from '../../../src/assets/company/img/no-record-found.png'
import CustomRangepicker from '../../components/company_panel/common/rangepicker';
import { ListInventoryReport } from '../../services/company_panel/report.services';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { LOADER_TIME } from '../../utils/Constants';
import $ from "jquery";
import { GetParentCategories } from '../../services/company_panel/categoryService';
import { GetAllSuppliers } from '../../services/company_panel/supplierService';
import GlobalLoader from '../../components/company_panel/common/globalLoader';


const InventoryReportList = () => {

    const breadcrumbs = [{ title: "Dashboard", url: "/company/dashboard" }, { title: "Pages", url: "" },]
    const [list, setList] = useState([])
    const [dataLength, setDataLength] = useState()
    const [itemPerPage, setItemPerPage] = useState(10)
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true)
    const [globalLoader, setGlobalLoader] = useState(false);
    const [search, setSearch] = useState({})
    const [globalSearch, setGlobalSearch] = useState("")
    const [resetdate, setResetDate] = useState(false);
    const selectRef = useRef(null);
    const [orderType,setOrderType] = useState();

    const[categoryData,setCategoryData] = useState([]);
    const [supplier,setSupplier] = useState({});

    const [isBrandChanged, setIsBrandChanged] = useState(false);
    const [isOutletChanged, setIsOutletChanged] = useState(false);

    useMemo(() => {
        document.addEventListener('brand-changed', function () {
            setIsBrandChanged(!isBrandChanged);
        });
        document.addEventListener('outlet-changed', function () {
            setIsOutletChanged(!isOutletChanged);
        })
    });

    useEffect(() => {
        if (search) {
            setLoader(true)
            setTimeout(() => {
                const formData = new FormData()
                formData.append("page", page)
                formData.append("per_page", itemPerPage)
                formData.append("sort", JSON.stringify(sorting))
                formData.append("search", JSON.stringify(search))
                formData.append("global_search", globalSearch)
                formData.append('company_id', getCompany().company_id);
                formData.append('brand_id', getBrandId());
                formData.append('outlet_id',getOutletId());
                ListInventoryReport(formData).then(data => {
                    setDataLength(data?.data?.response?.count || 0);
                    setList(data?.data?.response?.rows || [])
                    setLoader(false);
                }).catch(error => {
                    console.log("error ====> ", error);
                    setList([]);
                    setDataLength(0);
                    setLoader(false);
                })
            }, 500);
        }
    }, [sorting, search, globalSearch, page])

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    }

    const resetFilter = (e) => {
        e.preventDefault()
        setGlobalSearch("")
        prepareSearch()
        setSearch({})
        setResetDate(!resetdate)
        // $("#defaultstatus")[0].selectedIndex = 0
        $("#resetFilter")[0].selectedIndex = 0
        $("#supplierFilter")[0].selectedIndex = 0
    }

    const headerMapping = {
        "item_id": "Item ID",
        "item_name": "Item Name",
        "category_name": "Category Name",
        "current_stock_level": "Current Stock Level",
        "Price": "Total Price",
        "supplier_name": "Supplier Name",
        "supplier_email": "Supplier Email",
        "brand_name" : "Brand Name"
    };

    const handleExport = () => {
        setGlobalLoader(true);
        const formData = new FormData()
        formData.append("page", 1)
        formData.append("per_page", dataLength)
        formData.append("sort", JSON.stringify(sorting))
        formData.append("search", JSON.stringify(search))
        formData.append("global_search", globalSearch)
        formData.append('company_id', getCompany().company_id);
        formData.append('brand_id', getBrandId());
        formData.append('outlet_id',getOutletId());
        ListInventoryReport(formData).then(data => {
            setDataLength(data.data.response.count);
            const listData = data && data.data && data.data.response ? data.data.response.rows : [];
            const printData = listData.map((item) => {
                const transformedItem = {};
                // Extract fields from nested objects
                const ItemID = item?.inventory_id || 'N/A';
                const ItemName = item?.inventory_name || 'N/A';
                const category = item?.category_name || 'N/A';
                const stockLevel = item?.inventory_stock_quantity || 'N/A';
                const price = item?.raw_material_price + " " + "SAR" || 'N/A';
                const supplierName =  item?.suppliers.map((data) => data.supplier_name).join(', ') || 'N/A';
                const supplierEmail = item?.suppliers.map((data) => data.supplier_email).join(', ') || 'N/A';
                const brandName = capitalizeFirstLetter(item?.brand_name) || 'N/A'

                // Map fields according to headerMapping
                for (const key in headerMapping) {
                    if (headerMapping.hasOwnProperty(key)) {
                        const newKey = headerMapping[key];
                        switch (key) {
                            case "item_id":
                                transformedItem[newKey] = '#'+(ItemID);
                                break;
                            case "item_name":
                                transformedItem[newKey] = capitalizeFirstLetter(ItemName);
                                break;
                            case "category_name":
                                transformedItem[newKey] = capitalizeFirstLetter(category);
                                break;
                            case "current_stock_level":
                                transformedItem[newKey] = (stockLevel);
                                break;
                            case "Price":
                                transformedItem[newKey] = (price);
                                break;
                            case "supplier_name":
                                transformedItem[newKey] = capitalizeFirstLetter(supplierName);
                                break;
                            case "supplier_email":
                                transformedItem[newKey] = (supplierEmail);
                                break;
                            case "brand_name":
                                transformedItem[newKey] = (brandName);
                                    break;
                            default:
                                // Handle any unexpected keys
                                console.warn(`Unexpected key in headerMapping: ${key}`);
                                transformedItem[newKey] = 'N/A';
                                break;
                        }
                    }
                }
                return transformedItem;
            });

            const ws = XLSX.utils.json_to_sheet(printData, { header: Object.values(headerMapping) });
            ws['!cols'] = getExcelColumnWidths(printData, Object.values(headerMapping));
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            saveAs(blob, 'Inventory-Report.xlsx');
            // setTimeout(() => {
            //     setLoader(false);
            // }, LOADER_TIME);
            setGlobalLoader(true);
        }).catch(error => {
            // setTimeout(() => {
            //     setLoader(false);
            // }, LOADER_TIME);
            setGlobalLoader(true);
            console.log("error ====> ", error);
        })
    };

    const handleFilterChange = (e) => {
        if (e?.target.value) {
            prepareSearch("category_id", e.target.value);
        } else {
            prepareSearch("category_id", "");
        }
    };

    const handleFilterChangeSupplier = (e) => {
        if (e?.target.value) {
            prepareSearch("supplier_id", e.target.value);
        } else {
            prepareSearch("supplier_id", "");
        }
    };

    useEffect(() => {
        const formData = new FormData()
        formData.append('brand_id', getBrandId());
        GetParentCategories(formData).then(data => {
            setCategoryData(data && data.data && data.data.response ? data.data.response.rows : [])
        }).catch(error => {
            console.log("error ====> ", error);
        })
    }, [isBrandChanged])

    useEffect(() => {
        GetAllSuppliers({ brand_id: getBrandId() }).then(data => {
        setSupplier(data?.data?.response || []);
        }).catch(error => {
          console.log("error ====> ", error);
        });
    }, [isBrandChanged]);


    return (
        <>
            {globalLoader && <GlobalLoader/>}
            <div className="animation_fade">
                <div className='page-header d-flex align-items-center'>
                    <div className='page-header-left'>
                        <h4>Report</h4>
                    </div>
                    <div className='page-header-right ms-auto'>
                        <button onClick={handleExport} disabled={dataLength === 0} className="btn btn-primary ms-2">Export Report</button>
                    </div>
                </div>
                <div className="card custom-card overflow-hidden">
                    <div className='gap-20 border-bottom'>
                        <div className='col-12'>
                            <div className='d-flex justify-content-between align-items-center'>
                                <ConfigurationReportTab tab='inventory' />
                            </div>
                        </div>
                    </div>
                    <div className="gap-20">
                        <div className='page-header d-flex align-items-center mb-0'>
                            {/* <div className='page-header-left'></div> */}
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="form-group mb-0 rangepicker_container">
                                    <input type="search" className="form-control" value={globalSearch} placeholder="Search" onChange={(e) => { setGlobalSearch(e.target.value) }} />
                                </div>
                            </div>
                            <div className='page-header-right ms-auto'>
                                <div className='d-flex gap-3 align-items-center'>
                                    <div className="date-input">
                                        {/* <CustomRangepicker GetDateRange={(e) => { prepareSearch("created", e) }} resetdate={resetdate} /> */}
                                    </div>
                                    <div className="me-3">
                                        <div className="form-group mb-0 filter_icon_container filter_design">
                                            {/* <div className="select-down-arrow"> */}
                                                <select
                                                    ref={selectRef}
                                                    className={`form-control cp ${categoryData && categoryData.length > 5 ? 'scrollable-select' : ''}`}
                                                    onChange={handleFilterChange}
                                                    id="resetFilter"
                                                >
                                                    <option value="">Select Category</option>
                                                    {categoryData &&
                                                        categoryData.length > 0 &&
                                                        categoryData.map((option, i) => {
                                                            return (
                                                                <option key={i} value={option?.id}>
                                                                    {capitalizeFirstLetter(option?.name)}
                                                                </option>
                                                            );
                                                        })}
                                                </select>
                                            {/* </div> */}


                                        </div>
                                    </div>
                                    <div className="me-3">
                                        <div className="form-group mb-0 filter_icon_container filter_design">
                                            {/* <div className="select-down-arrow"> */}
                                                <select
                                                    ref={selectRef}
                                                    className={`form-control cp ${supplier && supplier.length > 5 ? 'scrollable-select' : ''}`}
                                                    onChange={handleFilterChangeSupplier}
                                                    id="supplierFilter"
                                                >
                                                    <option value="">Select Supplier</option>
                                                    {supplier &&
                                                        supplier.length > 0 &&
                                                        supplier.map((option, i) => {
                                                            return (
                                                                <option key={i} value={option?.id}>
                                                                    {capitalizeFirstLetter(option?.name)}
                                                                </option>
                                                            );
                                                        })}
                                                </select>
                                            {/* </div> */}


                                        </div>
                                    </div>
                                    <button type="reset" value='Reset' onClick={resetFilter} className="btn btn-primary mr-2">Reset Filter</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tabler-wrap">
                        <div className="table-responsive">
                            <table className="table table-custom">
                                <thead>
                                    <tr>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Item ID</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventories.id" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Item Name</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventories.item_name" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <span>Category Name</span>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Current Stock Level</span>
                                                {/* <Sorting sort={sorting} handleSort={handleSort} column="categories.name" /> */}
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Total Price</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="inventories.raw_material_price" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Supplier Name</span>
                                                {/* <Sorting sort={sorting} handleSort={handleSort} column="name" /> */}
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Supplier Email</span>
                                                {/* <Sorting sort={sorting} handleSort={handleSort} column="name" /> */}
                                            </div>
                                        </th>
                                        <th width="5%">
                                            <span>Brand Name</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ?
                                        <tr>
                                            <td colSpan={11}><Loader /></td>
                                        </tr> : <>
                                            {list.length ? list.map((row, i) => (
                                                <tr>
                                                    <td>#{row?.inventory_id}</td>
                                                    <td>{capitalizeFirstLetter(row?.inventory_name)}</td>
                                                    <td>{capitalizeFirstLetter(row?.category_name)}</td>
                                                     <td>{(row?.inventory_stock_quantity) || 'N/A'} {capitalizeAllFirstLetters(row?.uom_code)} </td>
                                                    <td>{capitalizeFirstLetter(row?.raw_material_price + " " + "SAR")}</td>
                                                    <td>
                                                        {capitalizeFirstLetter(
                                                            row && row?.suppliers.map((data) => data.supplier_name).join(', ') || 'N/A'
                                                        )}
                                                    </td>
                                                    <td>
                                                        {(
                                                            row && row?.suppliers.map((data) => data.supplier_email).join(', ') || 'N/A'
                                                        )}
                                                    </td>
                                                    <td>{capitalizeFirstLetter(row?.brand_name)}</td>
                                                </tr>
                                            )) : <tr>
                                                <td colSpan={11} className="text-center">
                                                    <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                    <p>No record found</p>
                                                </td>
                                            </tr>
                                            }</>}
                                </tbody>
                            </table>
                        </div>
                        <div className='tabler-footer'>
                            <div className='d-flex align-items-center'>
                                <div id="example1_info" role="status" className="table-result" aria-live="polite"><b>Total Records : {dataLength ? dataLength : "0"}</b></div>
                                {dataLength && dataLength > 0 ?
                                    <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "report", path: "/company/report/inventory_report/list" }]} /> : ""}
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer
                    position="top-right"
                    hideProgressBar={false}
                    autoClose={true | 1000}
                    newestOnTop={true}
                    closeOnClick={false}
                    draggable={false}
                    rtl={false}
                />

            </div>
        </>
    );
}

export default InventoryReportList